export default __webpack_public_path__ + "static/media/banner_img_2.37daa3ad.png";